import { Table, Text } from '@mantine/core';
import PropTypes from 'prop-types';
import prepareTranslate from '@/helpers/dictionary';
import styles from './style.module.css';

const TieredCommissionView = (props) => {
  const { tiers, label } = props;
  const t = prepareTranslate();

  if (!Array.isArray(tiers) || !tiers.length) return null;

  const rows = tiers.map((tier, index) => {
    const {
      from,
      to,
      rate,
    } = tier;

    const fromDisplay = from.toLocaleString('en-US');
    const toDisplay = to !== null && to !== undefined
      ? to.toLocaleString('en-US')
      : t('components.tieredCommissionInput.noLimit');

    return (
      <Table.Tr key={index}>
        <Table.Td>{fromDisplay}</Table.Td>
        <Table.Td>{toDisplay}</Table.Td>
        <Table.Td>{rate}</Table.Td>
      </Table.Tr>
    );
  });

  const headers = [
    t('components.tieredCommissionInput.headers.from'),
    t('components.tieredCommissionInput.headers.to'),
    t('components.tieredCommissionInput.headers.rate'),
  ];

  return (
    <div className={styles.container}>
      <Text size={'sm'} fw={'bold'} c={'var(--mantine-color-secondary-0)'}>{label}</Text>
      <Table withTableBorder={false} withColumnBorders={false}>
        <Table.Thead>
          <Table.Tr>
            {headers.map((header, index) => <Table.Th key={index} className={styles.th}>
              {header}
            </Table.Th>)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </div>
  );
};

TieredCommissionView.propTypes = {
  tiers: PropTypes.arrayOf(PropTypes.shape({
    from: PropTypes.number,
    to: PropTypes.number,
    rate: PropTypes.number,
  })),
  label: PropTypes.string,
};

export default TieredCommissionView;
